import { BaseClass } from './base-class';
import { BaseRepository } from '@interfaces/base-repository';
import { Site } from './site';

export class Address extends BaseClass implements BaseRepository {
    name: string;
    street: string;
    streetNumber: string;
    locality: string;
    postalCode: string;
    isReceiver: boolean;
    isSender: boolean;
    sites: Site[];
    phone: string;
    isChecked?: boolean;
    tags?: string[];

    constructor()
    constructor(
      name: string, street: string, streetNumber: string, locality: string, postalCode: string, isReceiver: boolean, isSender: boolean, sites: Site[], phone: string, tags?: string[])
    constructor(
      name?: string, street?: string, streetNumber?: string, locality?: string, postalCode?: string, isReceiver?: boolean, isSender?: boolean, sites?: Site[], phone?: string, tags?: string[]) {
        super();

        this.name = this.trim(name);
        this.street = this.trim(street);
        this.streetNumber = this.trim(streetNumber);
        this.locality = this.trim(locality);
        this.postalCode = this.trim(postalCode);
        this.isReceiver = isReceiver;
        this.isSender = isSender;
        this.sites = sites;
        this.phone = phone;
        if (tags) {
          tags.map(oneTag => {
              this.trim(oneTag).replace(' ', '').replace(':', '').toLowerCase();
          });
          this.tags = tags;
      }
    }

    static fromObject(object: Address): Address {
      return Object.assign(new Address(), {
        ...object,
          sites: object.sites?.map(o => Site.fromObject(o)) || []
      });
  }

    get display(): string {
        return `${this.name}`;
    }

    doesInclude(value: string): boolean {
        return this.some([this.name], value);
    }
}
